var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D2683889-DAB8-4DC4-B2CD-CF1A915A2C03") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.886275 0 0 0 0 0.909804 0 0 0 0 0.933333 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Deliverables",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Recruiter---Posts",
    transform: "translate(-423.000000, -294.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "item-2",
    transform: "translate(80.000000, 94.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "item"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(327.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cards-/-Post-card/1-Copy-8",
    transform: "translate(0.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cards-/-Post-card/1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Shape",
    stroke: "#E2E8EE",
    strokeWidth: 2,
    fill: "#F7F9FB",
    x: 1,
    y: 1,
    width: 78,
    height: 78,
    rx: 12
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "Component/icon/ic_Working-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Working-at"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-24",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  })), /*#__PURE__*/React.createElement("g", {
    id: "picture-landscape",
    transform: "translate(6.000000, 6.000000)",
    fill: "#92929D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,0 L6,0 C2.6862915,0 0,2.6862915 0,6 L0,30 C0,33.3137085 2.6862915,36 6,36 L30,36 C33.3137085,36 36,33.3137085 36,30 L36,6 C36,2.6862915 33.3137085,0 30,0 Z M10,8 C11.6568542,8 13,9.34314575 13,11 C13,12.6568542 11.6568542,14 10,14 C8.34314575,14 7,12.6568542 7,11 C7,9.34314575 8.34314575,8 10,8 L10,8 Z M32,29.66 C32.0919889,30.8578392 31.1975509,31.9043316 30,32 L6,32 L21.14,18.36 C21.6668689,17.8794116 22.4731311,17.8794116 23,18.36 L32,27.32 L32,29.66 Z",
    id: "Shape"
  })))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImage);
export default __webpack_public_path__ + "static/media/default-image.0f3a064fb2a72a65593b403180ac95f1.svg";
export { ForwardRef as ReactComponent };